import { Observable } from 'rxjs';
import { switchMap, flatMap, withLatestFrom } from 'rxjs/operators';
import { Action } from 'redux';
import { ofType, StateObservable } from 'redux-observable';
import {
  LoadRelease,
  LoadReleaseSuccess,
  LoadReleaseError,
} from '../action-creators';
import { LOAD_RELEASE } from '../actions';
import * as release from '@webapp/sdk/release';
import { Release } from '@common/types/release/release';
import { openRelease } from '../../../utils/release/open-release';
import AppState from '../../state';

export const loadReleaseEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, LoadRelease>(LOAD_RELEASE),
    withLatestFrom(state$),
    switchMap(
      async ([action, state]): Promise<
        [string?, Partial<Release>?, string?, string?, boolean?]
      > => {
        try {
          const draft = await release.get(action.artistId, action.releaseId);
          return [
            undefined,
            draft,
            action.artistId,
            state.router.location.pathname,
            action.fetchTracks,
          ];
        } catch (err) {
          return [(err as Error).message];
        }
      }
    ),
    flatMap(([errMsg, draft, artistId, location, fetchTracks]) => {
      if (errMsg) {
        return [new LoadReleaseError(errMsg)];
      }

      if (!(draft && artistId)) {
        return [new LoadReleaseError('Unknown Error')];
      }

      const actions: Action[] = [new LoadReleaseSuccess(draft, fetchTracks)];

      if (location && !location.includes(`${artistId}/${draft.id}`)) {
        actions.push(openRelease(artistId, draft.id as string));
      }

      return actions;
    })
  );
